// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__1u_Ly","title":"AfterFrontImage_title__3SB8c"};